import { render, staticRenderFns } from "./QMyProfileSubmenu.vue?vue&type=template&id=0a3f04c8&"
import script from "./QMyProfileSubmenu.vue?vue&type=script&lang=js&"
export * from "./QMyProfileSubmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports